function isSegmentInitialized() {
  return !!window.analytics
}

function track(eventName, properties = {}) {
  if (isSegmentInitialized()) {
    window.analytics.track(eventName, properties)
  }
}

function page(pageName, properties = {}) {
  if (isSegmentInitialized()) {
    window.analytics.page(pageName, properties)
  }
}

function identify(userId, traits = {}) {
  if (isSegmentInitialized()) {
    window.analytics.identify(userId, traits)
  }
}

function reset() {
  if (isSegmentInitialized()) {
    window.analytics.reset()
  }
}

export default {
  track,
  page,
  identify,
  reset,
}
